export const siteInfo = {
  name: '6080影院',
  tagline: '电影大全 | 最新电影 经典电影 动作电影 喜剧电影免费看',
  description: '6080影院打造电影大全片库，最新电影、经典电影、动作电影、喜剧电影全覆盖，高清免费在线随时点播。不缓冲播放，畅享极致观影体验。',
  keywords: '电影大全,最新电影,经典电影,动作电影,喜剧电影,6080影院,免费电影,高清在线,影视大全,不缓冲播放',
  url: 'https://www.6080cinema.com',
  founded: '2020',
  brandStory: '6080影院成立于2020年，致力于为广大电影爱好者打造一站式高清电影大全平台。我们汇聚了海量最新电影、经典电影、动作电影、喜剧电影等各类影片资源，坚持免费向用户开放，让每一位用户都能随时随地畅享高清观影体验。经过多年发展，6080影院已成为国内领先的免费电影大全平台，累计服务超过千万用户，赢得了广泛的口碑与信赖。',
  features: [
    {
      title: '海量片库',
      description: '汇聚数万部电影资源，涵盖最新电影、经典电影、动作电影、喜剧电影等全类型，打造最全电影大全。',
    },
    {
      title: '高清画质',
      description: '所有影片支持高清画质播放，配合先进的不缓冲播放技术，确保流畅观影体验。',
    },
    {
      title: '完全免费',
      description: '6080影院始终坚持免费向用户开放，无需付费会员，无需注册登录，随时随地畅享电影盛宴。',
    },
    {
      title: '极速更新',
      description: '院线新片第一时间上线，最新电影同步更新，让你永远走在观影前沿。',
    },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '资深影迷',
      content: '6080影院是我用过最好的电影大全网站，片源丰富，更新快，而且完全不卡顿，不缓冲播放的体验真的太棒了！',
      rating: 5,
    },
    {
      name: '李女士',
      role: '影视爱好者',
      content: '每天下班回家都会打开6080影院找电影看，分类很清晰，最新电影、经典电影一目了然，推荐给身边所有朋友。',
      rating: 5,
    },
    {
      name: '王同学',
      role: '大学生',
      content: '作为学生党，6080影院完全免费这点太良心了。电影大全分类齐全，想看什么类型都有，高清画质也很赞。',
      rating: 5,
    },
    {
      name: '刘先生',
      role: 'IT从业者',
      content: '用过很多电影网站，6080影院的不缓冲播放技术确实厉害，高清在线播放毫无压力，片库也是目前见过最全的。',
      rating: 5,
    },
  ],
  contact: {
    email: 'contact@6080cinema.com',
    wechat: '6080cinema',
    qq: '1234567890',
    phone: '400-888-6080',
    address: '北京市朝阳区建国路88号',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  stats: [
    { label: '影片总数', value: '50,000+' },
    { label: '日活用户', value: '100万+' },
    { label: '累计服务', value: '5,000万+' },
    { label: '分类覆盖', value: '20+' },
  ],
};

export const faqs = [
  {
    question: '6080影院的电影都是免费的吗？',
    answer: '是的，6080影院所有电影资源完全免费向用户开放，无需任何付费会员或订阅，您可以随时随地畅享电影大全中的全部内容。',
  },
  {
    question: '6080影院的画质如何？是否真的不缓冲？',
    answer: '6080影院所有影片均支持高清画质播放，采用先进的不缓冲播放技术，在正常网络环境下几乎无缓冲等待，为您提供流畅的观影体验。',
  },
  {
    question: '6080影院有哪些电影分类？',
    answer: '6080影院的电影大全涵盖最新电影、经典电影、动作电影、喜剧电影、科幻电影、爱情电影、恐怖电影、动画电影、纪录片等丰富分类，满足各类观影需求。',
  },
  {
    question: '需要注册账号才能观看吗？',
    answer: '不需要。6080影院无需注册登录即可直接观看所有电影，我们致力于降低用户的使用门槛，让观影更简单、更便捷。',
  },
  {
    question: '新电影多久能上架？',
    answer: '6080影院拥有专业的更新团队，院线新片通常在首映后第一时间上线，最新电影同步更新频率极高，确保您不错过任何一部好片。',
  },
];